module.exports = __webpack_public_path__ + "img/1-5.65a7fefe.png";